export default __webpack_public_path__ + "static/media/Karna.935dd305.png";